import { useContext, useEffect, useRef } from 'react';

import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

import { AppContext } from "../../../AppContext";

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import Assessment from '@mui/icons-material/Assessment';
import Article from '@mui/icons-material/Article';
import DataLoading from '../ui/DataLoading';
import AppNav from "../../../components/app-nav";
import { addEventLog } from 'utils/functions/eventLogFunctions';


const Home = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const navigate = useNavigate();
  const { embeddingData } = useContext(AppContext);
  console.log({embeddingData})
  const loginuser = localStorage.getItem("currentUser") ?? "unknown_user";
  const hasLogged = useRef(false);

  useEffect(() => {
      if (hasLogged.current) return;
		  hasLogged.current = true;
  }, []);

  if (!isAuthenticated) {
    return (
      <Container maxWidth={false}>
        <Typography variant='h5' component="h2" sx={{ my: 3 }} ></Typography>
        
      </Container >
    )
  }

if (isAuthenticated && embeddingData.user !== "" && embeddingData.tenantName === "" && !embeddingData.workspaceArtifactsLoading) {
  return (
    <>
    
      <AppNav user={loginuser} className="report-app-nav" />

      <Container maxWidth={false} sx={{ position: "absolute", top: "52px", left: "48px" }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            mt: "55px",
            mb: "20px",
            fontFamily: "inter, sans-serif !important",
            letterSpacing: "0",
            fontSize: 24,
            fontWeight: 700
          }}
        >
          Lab Reports
        </Typography>

        <Alert
          sx={{
            border: 1,
            padding: 2,
            mt: 0,
            fontFamily: "jost",
            fontSize: "16px",
            maxWidth: "980px"
          }}
          severity="info"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // Stack on small screens, row on larger ones
              alignItems: "flex-start",
              gap: 2
            }}
          >
            {/* Text Section */}
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "inter, sans-serif !important",
                  letterSpacing: "0",
                  fontSize: 20,
                  fontWeight: 700,
                  marginTop: "-4px",
                  marginBottom: '10px'
                }}
              >
                Unlock Deeper Insights with Lab Reports in Relay
              </Typography>
              <p style={{paddingBottom:"10px"}}>You can now review molecular lab reports alongside your ATP results in Relay. Regular lab testing complements ATP testing, 
              providing a more complete picture of microbial activity.</p>

              <p style={{paddingBottom:"10px"}}>Our experts are here to support you from sample collection to data interpretation, 
                ensuring you have the insights needed to stay in control of your systems.</p>

              <p style={{paddingBottom:"10px"}}><a className="!text-[#0092C8]" href="https://my.luminultra.com/hc/en-us/requests/new" target="_blank">Contact us</a> to learn more, or {" "}
              <Typography
                onClick={() => navigate('/')}
                sx={{
                  display: "inline",
                  cursor: "pointer",
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "rgb(0, 147, 200)",
                  fontFamily: "jost"
                }}
              >
                return to your ATP testing.
              </Typography> 
              {" "}</p>

              <p style={{paddingBottom:"10px"}}><em><strong>Already a lab customer looking for your reports?</strong> We're rolling out report access within Relay in waves — check 
                back soon for yours.</em></p>
            </Box>

            {/* Image Section */}
            <Box component="img"
              src="/assets/img/Sample-Preservation-Kit_06.jpg" 
              alt="Lab Reports Preview"
              sx={{
                maxWidth: "410px",
                width: "100%", 
                borderRadius: "4px",
                flexShrink: 0
              }}
            />
          </Box>
        </Alert>
      </Container>

    </>
  )
}

if (embeddingData.workspaceArtifactsLoading || inProgress !== "none") {
  return <DataLoading />
}

if (isAuthenticated && embeddingData.tenantName && !embeddingData.workspaceArtifactsLoading) {
  return (
    <>
      <AppNav user={loginuser} className="report-app-nav" />

      <Container maxWidth={false} sx={{ position: "absolute", top: "52px" }}>
        <Container maxWidth="xl">
          <Typography variant='h5' component="h2" sx={{
            mt: "55px", fontFamily: "inter, sans-serif !important", letterSpacing: "0", fontSize: 24, fontWeight: 700, pl: "48px"
          }} >Lab Reports</Typography>

          <Typography variant='h5' component="h2" sx={{
            mt: "20px", fontFamily: "jost, sans-serif !important", letterSpacing: "0", fontSize: 16, fontWeight: "inherit", pl: "48px"
          }} >To get started, select an available report type from the list. </Typography>

          <Typography variant='h6' component="h4" sx={{ mt: 3, borderBottom: "1px solid #444444", mb: "20px", paddingBottom: "6px", pl: "48px" }} >Available Reports</Typography>

          <Grid container >
            <Grid item xs={6} sx={{ pr: "4px", pl: "48px" }} >
              <List sx={{ backgroundColor: "" }} disablePadding  >
                {embeddingData?.reports?.map((report) => (
                  <ListItem key={report.id} divider dense sx={{ p: "0px", m: 0, border: "none" }} >
                    <ListItemButton onClick={() => { navigate("/reports/" + report.id); }} sx={{
                      p: 0, m: "0 0 15px", border: "1px solid #CCCCCC",
                      borderRadius: "2px", boxShadow: "rgba(0, 0, 0, 0.08) 0px 3px 4px 0px"
                    }} >
                      <ListItemAvatar sx={{ p: 0, minWidth: "44px" }}>
                        <Avatar sx={{ width: "32px", height: "32px", ml: "4px", backgroundColor: "rgba(0,0,0,0)" }}>
                          {report.reportType === "PowerBIReport" ?
                            <Assessment sx={{ color: "#0093c8" }} /> :
                            <Article sx={{ color: "#0093c8" }} />}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={report.name}
                        primaryTypographyProps={{ fontSize: "16px", fontWeight: "bold", fontFamily: "inter !important", padding: "12px 0" }}
                        // secondary={report.reportType === "PowerBIReport" ? "Power BI Report" : "Paginated Report"}
                        secondaryTypographyProps={{ fontSize: "12px", color: "#555555" }}
                        sx={{ p: 0, m: 0 }} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Container>
        <Box>
          &nbsp;
        </Box>
      </Container>

    </>
  )
}
return <></>
}

export default Home;